import React from 'react';

// Lightning bolt icon for Voltage
export const VoltageIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Electrical plug icon for Current
export const CurrentIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M12 2v6" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round"
    />
    <path 
      d="M12 16v6" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round"
    />
    <path 
      d="M8 8h8" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round"
    />
    <path 
      d="M8 16h8" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round"
    />
    <circle 
      cx="12" 
      cy="12" 
      r="2" 
      stroke="currentColor" 
      strokeWidth="2"
    />
  </svg>
);

// Bar chart icon for Frequency
export const FrequencyIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <rect 
      x="3" 
      y="16" 
      width="3" 
      height="5" 
      fill="#ef4444" 
      stroke="currentColor" 
      strokeWidth="1"
    />
    <rect 
      x="7" 
      y="12" 
      width="3" 
      height="9" 
      fill="#10b981" 
      stroke="currentColor" 
      strokeWidth="1"
    />
    <rect 
      x="11" 
      y="8" 
      width="3" 
      height="13" 
      fill="#3b82f6" 
      stroke="currentColor" 
      strokeWidth="1"
    />
    <rect 
      x="15" 
      y="14" 
      width="3" 
      height="7" 
      fill="#f59e0b" 
      stroke="currentColor" 
      strokeWidth="1"
    />
  </svg>
);

// Balance scale icon for Power Factor
export const PowerFactorIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M12 2v20" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round"
    />
    <path 
      d="M8 6l4-4 4 4" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M8 18l4 4 4-4" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <circle 
      cx="6" 
      cy="12" 
      r="2" 
      stroke="currentColor" 
      strokeWidth="2"
    />
    <circle 
      cx="18" 
      cy="12" 
      r="2" 
      stroke="currentColor" 
      strokeWidth="2"
    />
  </svg>
);
